import moment from "moment";
import { DATE_FORMATS } from "../constants";
import getAvatarUrl from "./get-avatar-url";

const { DATE_PICKER_FORMAT } = DATE_FORMATS;

export const formatNumber = (number, currency = "usd") => {
  const formatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency.toUpperCase(),
  });
  return formatter.format(number);
};

export const formatStripeDate = (date, format = DATE_PICKER_FORMAT) => {
  const dateMoment = moment.unix(date);
  return dateMoment.format(format);
};

const FormatSub = function formatSubscriber(sub) {
  /** formatting dates */
  const created_date = moment.unix(sub.created);
  const created = created_date.format(DATE_PICKER_FORMAT);

  // Pass roster rows (subscribers-list-export.js's isPass rows) carry no
  // current_period_start/end — they're one-time PaymentIntents, not
  // subscriptions with a billing cycle. moment.unix(undefined) produces an
  // invalid moment whose .format() call renders the literal string
  // "Invalid date" (notably a real string, not falsy — it would otherwise
  // sail straight into the CSV export untouched), so guard both the same
  // way lastPayment already does below.
  const current_period_start_date = sub.current_period_start
    ? moment.unix(sub.current_period_start)
    : null;
  const current_period_start = current_period_start_date
    ? current_period_start_date.format(DATE_PICKER_FORMAT)
    : "";

  const current_period_end_date = sub.current_period_end
    ? moment.unix(sub.current_period_end)
    : null;
  const current_period_end = current_period_end_date
    ? current_period_end_date.format(DATE_PICKER_FORMAT)
    : "";

  /** formatting the plan text */
  const plan = Object.assign({}, sub.plan);
  plan.interval = sub.plan
    ? plan.nickname
      ? plan.nickname
      : plan.interval === "month"
        ? "Monthly"
        : "Annual"
    : "";

  /** formatting the avatar url */
  const customer_avatar = Object.assign({}, sub.customer_avatar);
  customer_avatar.url = getAvatarUrl({
    name: sub.customer_name,
    avatar: sub.customer_avatar,
  });

  const canceled = sub.status === "canceled" || !!sub.cancel_at_period_end;

  /** whole months this member has been with the coach — a number, so it
   * sorts; the table words it ("14 months") */
  const tenure = created_date.isValid()
    ? moment().diff(created_date, "months")
    : null;

  const lastPayment = sub.lastPaymentAt
    ? moment.unix(sub.lastPaymentAt).format(DATE_PICKER_FORMAT)
    : null;

  /** adding/overwritting the mapped obj with the formatted fields */
  return Object.assign({}, sub, {
    created,
    current_period_start,
    current_period_end,
    current_period_end_date,
    plan,
    customer_avatar,
    canceled,
    tenure,
    lastPayment,
    // Raw unix values for sorting — `created` and `current_period_start`
    // above are overwritten with display strings, which sort as text.
    createdAt: sub.created || 0,
    lastPaymentAt: sub.lastPaymentAt || sub.current_period_start || 0,
  });
};

export default FormatSub;
